<!-- Role and ID's 
Admin = 1
BU Head = 2
User = 3
HR = 4
Director = 5 -->

<div class="nav-side-menu sidebar hover-d">
  <a href="javascript:void(0);" class="brand-link">
    <span class="logo-img"></span>
    <!-- <img class="brand-image" src="/assets/img/brand/logo-high-original.png" /> -->
    <!-- <img class="brand-minized-image" src="../../../assets/brand/logo-high-dark.jpg" /> --> <!--will use leter-->
  </a>

  <nav class="nav" role="navigation">
    <ul class="nav__list">
      <li>
        <a class="nav-link" routerLinkActive="active" routerLink="/dashboard"> <!--class="active"-->
          <span class="left-icon"><i class="fa fa-solid fa-chart-pie"></i></span>
          <span class="menu-name">Dashboard</span>
        </a>
      </li>

      <li *ngIf="role !== '1'">
        <a class="nav-link" routerLinkActive="active" routerLink="/redemption/redeem-reward-points"> <!--class="active"-->
          <span class="left-icon"><i class="fa fa-solid fa-coins"></i></span>
          <span class="menu-name">Redeem Points</span>
        </a>
      </li>

      <li *ngIf="role !== '1'">
        <a class="nav-link" routerLinkActive="active" routerLink="/redemption/event-participation"> <!--class="active"-->
          <span class="left-icon"><i class="fa-regular fa-calendar-check"></i></span>
          <span class="menu-name">Event Participation</span> 
        </a>
      </li>

      <li *ngIf="role === '1'">
        <a class="nav-link" routerLinkActive="active" routerLink="/redemption/assign-rewards"> <!--class="active"-->
          <span class="left-icon"><i class="fa fa-solid fa-coins"></i></span>
          <span class="menu-name">Approve Rewards</span>
        </a>
      </li>

      <li *ngIf="role === '1'">
        <a class="nav-link" routerLinkActive="active" routerLink="/redemption/approve-event-participation"> <!--class="active"-->
          <span class="left-icon"><i class="fa fa-solid fa-coins"></i></span>
          <span class="menu-name">Approve Event Participation</span>
        </a>
      </li>

      <!---Master Menu-->
      <li class="sub-menu-li">
        <input id="group-1" type="checkbox" hidden />
        <label class="nav-group" for="group-1">
          <span class="left-icon"><i class="fa fas nav-icon fa-desktop"></i></span>
          <span class="menu-name">Masters</span> <span class="right-arrow fa fa-angle-right"></span>
        </label>

        <ul class="group-list">

          <li *ngIf= "role === '1'">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/employee-master/list-employee-master">
              <span class="left-icon"><i class="fa fa-solid fa-user-tie"></i></span>
              <span class="menu-name">Employee Master</span>
            </a>
          </li>

          <li *ngIf="role === '1'">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/stream-master/stream-list">
              <span class="left-icon"><i class="fa-solid fa-building"></i></span>
              <span class="menu-name">Stream Master</span>
            </a>
          </li>

          <li *ngIf="role === '1'">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/bu-master/bu-list">
              <span class="left-icon"><i class="fa-solid fa-building"></i></span>
              <span class="menu-name">BU Master</span>
            </a>
          </li>

          <!--second level menu -->
          <li *ngIf="role === '3' || role === '2' || role === '1'">
            <input id="sub-group-1" type="checkbox" hidden />
            <label class="nav-group" for="sub-group-1">
              <span class="left-icon"><i class="fa fa-solid fa-users-rays"></i></span>
              <span class="menu-name">Certification Master</span>
              <span class="right-arrow fa fa-angle-right"></span>
            </label>
                <!-- Nested submenu items -->
                <ul class="sub-group-list">
                  <!-- Certification Master for BU Head -->
                  <li *ngIf="role === '2' || role === '1'">
                    <a class="nav-link" routerLinkActive="active"
                      routerLink="/master/certification-master/certification-list">
                      <span class="left-icon"><i class="fa fa-solid fa-ranking-star"></i></span>
                      <span class="menu-name">Certifications</span>
                    </a>
                  </li>
              
                  <!-- Certification Allocation for BU Head -->
                  <li *ngIf="role === '2'|| role === '1'">
                    <a class="nav-link" routerLinkActive="active"
                      routerLink="/master/allocation-master/certificate-allocation">
                      <span class="left-icon"><i class="fa fa-regular fa-handshake"></i></span>
                      <span class="menu-name">Assign Certification</span>
                    </a>
                  </li>
                  
                  <!-- Allocated Certifications for User or Admin -->
                  <li *ngIf="role === '3' ">
                    <a class="nav-link" routerLinkActive="active"
                      routerLink="/master/allocated-certification/allocated-certification-list">
                      <span class="left-icon"><i class="fa fa-regular fa-handshake"></i></span>
                      <span class="menu-name">Assigned Certifications</span>
                    </a>
                  </li>
              
                  <!-- <li *ngIf="role === '3' || role === '1'">
                    <a class="nav-link" routerLinkActive="active"
                      routerLink="/master/certification-master/approved-certification-list">
                      <span class="left-icon"><i class="fa fa-regular fa-thumbs-up"></i></span>
                      <span class="menu-name">Approved</span>
                    </a>
                  </li>

                  <li *ngIf="role === '3' || role === '1'">
                    <a class="nav-link" routerLinkActive="active"
                      routerLink="/master/certification-master/pending-for-approval-certification-list">
                      <span class="left-icon"><i class="fa fa-solid fa-hourglass-half"></i></span>
                      <span class="menu-name">Pending</span>
                    </a>
                  </li>

                  <li *ngIf="role === '3' || role === '1'">
                    <a class="nav-link" routerLinkActive="active"
                      routerLink="/master/certification-master/rejected-certification-list">
                      <span class="left-icon"><i class="fa fa-regular fa-thumbs-down"></i></span>
                      <span class="menu-name">Rejected</span>
                    </a>
                  </li>

                  <li *ngIf="role === '3' || role === '1'">
                    <a class="nav-link" routerLinkActive="active"
                      routerLink="/master/certification-master/bu-assigned-certification-list">
                      <span class="left-icon"><i class="fa fa-regular fa-thumbs-down"></i></span>
                      <span class="menu-name">BU Assigned Certification</span>
                    </a>
                  </li> -->

                  <!-- Certification Approval for BU Head -->
                  <li *ngIf="role === '2'|| role === '1'">
                    <a class="nav-link" routerLinkActive="active"
                      routerLink="/master/certification-approval/certification-approval-list">
                      <span class="left-icon"><i class="fa fa-solid fa-person-circle-check"></i></span>
                      <span class="menu-name">Certification Approval</span>
                    </a>
                  </li>

                </ul>
           </li>
          
          <li *ngIf="role === '3' || role === '2' || role === '1'">
            <input id="sub-group-2" type="checkbox" hidden />
            <label class="nav-group" for="sub-group-2">
                <span class="left-icon"><i class="fa fa-solid fa-user-check"></i></span>
                <span class="menu-name">Customer Referral</span>
                <span class="right-arrow fa fa-angle-right"></span>
            </label>
        
            <ul class="sub-group-list">
                <li *ngIf="role==='3'">
                    <a class="nav-link" routerLinkActive="active" routerLink="/master/customer-referral-master/customer-referral-list">
                        <span class="left-icon"><i class="fa fa-solid fa-list-check"></i></span>
                        <span class="menu-name">Customer List</span>
                    </a>
                </li>

                <li *ngIf="role==='3'">
                  <a class="nav-link" routerLinkActive="active" routerLink="/master/customer-referral-master/referral-assign-list">
                      <span class="left-icon"><i class="fa fa-solid fa-list-check"></i></span>
                      <span class="menu-name">Referral Assign List</span>
                  </a>
              </li>
        
                <!-- <li *ngIf="role==='3'">
                  <a class="nav-link" routerLinkActive="active" routerLink="/master/customer-referral-master/approved-customer-referrals">
                      <span class="left-icon"><i class="fa fa-regular fa-thumbs-up"></i></span>
                      <span class="menu-name">Approved</span>
                  </a>
              </li> -->

              <!-- <li *ngIf="role==='3'">
                <a class="nav-link" routerLinkActive="active" routerLink="/master/customer-referral-master/rejected-customer-referrals">
                    <span class="left-icon"><i class="fa fa-regular fa-thumbs-down"></i></span>
                    <span class="menu-name">Rejected</span>
                </a>
            </li> -->

                <li *ngIf="role==='2'|| role === '1'">
                    <a class="nav-link" routerLinkActive="active" routerLink="/master/customer-referral-master/referral-validation-list">
                        <span class="left-icon"><i class="fa fa-solid fa-users-rectangle"></i></span>
                        <span class="menu-name">Customer Referral Validation</span>
                    </a>
                </li>

                <li *ngIf="role==='2'|| role === '1'">
                  <a class="nav-link" routerLinkActive="active"  (click)="toAssignPageForAdmin()">
                    <span class="left-icon"><i class="fa fa-solid fa-list-check"></i></span>
                    <span class="menu-name">Customer Referral Assign</span>
                </a>
              </li>
        
                <li *ngIf="role==='2'|| role === '1'">
                    <a class="nav-link" routerLinkActive="active" routerLink="/master/customer-referral-master/referral-approval-list">
                        <span class="left-icon"><i class="fa fa-solid fa-stamp"></i></span>
                        <span class="menu-name">Customer Referral Approval</span>
                    </a>
                </li>
            </ul>
          </li>
        
        <li *ngIf="role === '3' || role === '4'|| role === '1'">
            <input id="sub-group-3" type="checkbox" hidden />
            <label class="nav-group" for="sub-group-3">
                <span class="left-icon"><i class="fa fa-solid fa-user-tie"></i></span>
                <span class="menu-name">Employee Referral</span>
                <span class="right-arrow fa fa-angle-right"></span>
            </label>
        
            <ul class="sub-group-list">
                  <li *ngIf="role==='3'">
                      <a class="nav-link" routerLinkActive="active" routerLink="/master/employee-referral-master/employee-referral-list">
                          <span class="left-icon"><i class="fa fa-solid fa-list-check"></i></span>
                          <span class="menu-name">Employee List</span>
                      </a>
                  </li>

                  <!-- <li *ngIf="role==='3'">
                    <a class="nav-link" routerLinkActive="active" routerLink="/master/employee-referral-master/approved-employee-referrals">
                        <span class="left-icon"><i class="fa fa-regular fa-thumbs-up"></i></span>
                        <span class="menu-name">Approved</span>
                    </a>
                </li>

                <li *ngIf="role==='3'">
                  <a class="nav-link" routerLinkActive="active" routerLink="/master/employee-referral-master/rejected-employee-referrals">
                      <span class="left-icon"><i class="fa fa-regular fa-thumbs-down"></i></span>
                      <span class="menu-name">Rejected</span>
                  </a>
                </li> -->
        
                <li *ngIf="role==='4'|| role === '1'">
                    <a class="nav-link" routerLinkActive="active" routerLink="/master/employee-referral-master/employee-referral-validation-list">
                        <span class="left-icon"><i class="fa fa-solid fa-users-gear"></i></span>
                        <span class="menu-name">Employee Referral Validation</span>
                    </a>
                </li>
        
                <li *ngIf="role==='4'|| role === '1'">
                    <a class="nav-link" routerLinkActive="active" routerLink="/master/employee-referral-master/employee-referral-approval-list">
                        <span class="left-icon"><i class="fa fa-solid fa-stamp"></i></span>
                        <span class="menu-name">Employee Referral Approval</span>
                    </a>
                </li>
            </ul>
        </li>

        <li *ngIf="role === '3' || role === '2' || role === '1'">
          <input id="sub-group-4" type="checkbox" hidden />
          <label class="nav-group" for="sub-group-4">
              <span class="left-icon"><i class="fa fa-regular fa-folder-open"></i></span>
              <span class="menu-name">Program Master</span>
              <span class="right-arrow fa fa-angle-right"></span>
          </label>
      
          <ul class="sub-group-list">
              <li *ngIf="role==='2'|| role === '1'">
                  <a class="nav-link" routerLinkActive="active" routerLink="/master/program-master/program-list">
                      <span class="left-icon"><i class="fa-solid fa-users"></i></span>
                      <span class="menu-name">Program</span>
                  </a>
              </li>
      
              <li *ngIf="role==='2'|| role === '1'">
                  <a class="nav-link" routerLinkActive="active" routerLink="/master/program-master/approve-programs">
                      <span class="left-icon"><i class="fa-solid fa-users"></i></span>
                      <span class="menu-name">Approval</span>
                  </a>
              </li>
      
              <li *ngIf="role==='3'">
                  <a class="nav-link" routerLinkActive="active" routerLink="/master/program-master/programs-to-complete">
                      <span class="left-icon"><i class="fa fa-regular fa-handshake"></i></span>
                      <span class="menu-name">Allocated</span>
                  </a>
              </li>
<!-- 
              <li *ngIf="role==='3'">
                <a class="nav-link" routerLinkActive="active" routerLink="/master/program-master/pending-for-approval-programs-list">
                    <span class="left-icon"><i class="fa fa-solid fa-champagne-glasses"></i></span>
                    <span class="menu-name">Completed</span>
                </a>
              </li> -->

              <!-- <li *ngIf="role==='3'">
                <a class="nav-link" routerLinkActive="active" routerLink="/master/program-master/approved-programs-list">
                    <span class="left-icon"><i class="fa fa-regular fa-thumbs-up"></i></span>
                    <span class="menu-name">Approved</span>
                </a>
              </li> -->

              <!-- <li *ngIf="role==='3'">
                <a class="nav-link" routerLinkActive="active" routerLink="/master/program-master/rejected-programs-list">
                    <span class="left-icon"><i class="fa fa-regular fa-thumbs-down"></i></span>
                    <span class="menu-name">Rejected</span>
                </a>
              </li> -->

          </ul>
        </li>

        <li *ngIf="role === '3' || role === '2' || role === '1'">
          <input id="sub-group-5" type="checkbox" hidden />
          <label class="nav-group" for="sub-group-5">
              <span class="left-icon"><i class="fa-brands fa-elementor"></i></span>
              <span class="menu-name">Event Master</span>
              <span class="right-arrow fa fa-angle-right"></span>
          </label>
      
          <ul class="sub-group-list">
              <li *ngIf="role==='2'|| role === '1'">
                  <a class="nav-link" routerLinkActive="active" routerLink="/master/event-master/event-list">
                      <span class="left-icon"><i class="fa-solid fa-users"></i></span>
                      <span class="menu-name">Events</span>
                  </a>
              </li>
          </ul>
        </li>
        

         <li *ngIf="role === '1'">
            <a class="nav-sub-link" routerLinkActive="active" routerLink="/master/voucher-master/voucher-list">
              <span class="left-icon"><i class="fa-solid fa-building"></i></span>
              <span class="menu-name">Voucher Master</span>
            </a>
          </li>

        </ul>
      </li>
      <!---Master Menu-->

    </ul>
  </nav>

  <div class="mini-sidebar">
    <span (click)="togglemini()"></span>
  </div>
</div>